
import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination'; 
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { VehicleService } from '../_Services/vehicle.service';
import { CommonService } from '../_Services/common.service';

import { Router, ActivatedRoute } from '@angular/router'; 
@Component({ 
  	templateUrl: 'vehicles.component.html'
})

export class VehiclesComponent {
 	p: any = 1; 

    model: any = {ofs: ''}

    ofs = [];

    paginator = [];

	constructor(private vehicleService: VehicleService, private commonService: CommonService) { 
 
	}  

    changeShape(ofs){ 
        this.model.ofs = ofs;
    }

	vehicles = [];  

	pageChanged(page: Number) {
		if(page == undefined) {
            page = 1;
        }
        this.p = page; 
		this.vehicleService.getVehicleByOfs(page, this.model).subscribe(result => { 
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            });  
	}  
   
	ngOnInit() {
        this.vehicleService.getVehicleByOfs(this.p, null).subscribe(result => { 
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            }); 
        this.commonService.getOfs().subscribe(result => { 
                this.ofs = result;
            });  
 	}
}


// WEBPACK FOOTER //
// ./src/app/debts/vehicles.component.ts